'use strict';

var $ = require('jquery'),
    frontendKit = require('../frontend/utils');

require('jquery-mask-plugin');

var cpfInputValue = '',
    cpfInputField = $('#registration-form-cpf'),
    regexMatcher = /(\d)\1{10}/gmi,
    sumValue = 0,
    sumRest = 0,
    valueParsed = 0,
    isCpfValid = false,
    cpfChecker = '',
    i = 0,
    maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {
        onKeyPress: function(val, e, field, options) {
            field.mask(maskBehavior.apply({}, arguments), options);
        }
    };


module.exports = {
    cpfValidator: function(ev) {
        if (ev === null || ev === undefined || ev === '') return;

        var _self = this;

        return {
            showError: function() {
                cpfInputField.siblings('.invalid-feedback').html('Por favor insira um CPF válido');
                cpfInputField.addClass('is-invalid');
            },

            testCpf: function(cpf) {
                if (cpf === null || cpf === undefined || cpf === '') return;

                for (i = 1; i <= 9; i++) {
                    valueParsed = parseInt(cpf.substring(i - 1, i), 10);
                    sumValue += valueParsed * (11 - i);
                }

                sumRest = (sumValue * 10) % 11;
                valueParsed = parseInt(cpf.substring(9, 10), 10);

                if ((sumRest === 10) || (sumRest === 11))  sumRest = 0;
                if (sumRest !== valueParsed) return false;

                sumValue = 0;
                for (i = 1; i <= 10; i++) {
                    valueParsed = parseInt(cpf.substring(i - 1, i), 10);
                    sumValue += valueParsed * (12 - i);
                }

                sumRest = (sumValue * 10) % 11;
                valueParsed = parseInt(cpf.substring(10, 11), 10);

                if ((sumRest === 10) || (sumRest === 11))  sumRest = 0;
                if (sumRest !== valueParsed) return false;

                return true;
            },

            validateCpf: frontendKit.debounce(function(ev) {
                if (ev === null || ev === undefined || ev === '') return;

                cpfChecker = _self.cpfValidator(ev);
                isCpfValid = false;
                window.isCpfValidObj = false;

                sumValue = 0;
                cpfInputValue = cpfInputField.val();
                cpfInputField.removeClass('is-invalid');
                cpfInputField.siblings('.invalid-feedback').html('');

                if (typeof cpfInputValue !== 'string') return;

                cpfInputValue = cpfInputValue.replace(/[\s.-]*/igm, '');

                if (cpfInputValue.match(regexMatcher)) {
                    cpfChecker.showError();

                    return;
                }

                isCpfValid = cpfChecker.testCpf(cpfInputValue);
                window.isCpfValidObj = isCpfValid;

                if (isCpfValid === false) {
                    cpfChecker.showError();
                }

                return this;
            }, 1000)
        };
    },

    maskApplier: frontendKit.debounce(function(ev) {
        if(ev == undefined || ev == null || ev == '') return;
        $('input[name*=\"phone\"]').mask(maskBehavior, options);
        $('input[name*=\"postalCode\"]').mask('00000-000');

        $('body').off('click', '.edit-address-link', this.maskApplier);
    }, 1000),

    bindEvHandlers: function() {
        $('body').on('click', '.edit-address-link', this.maskApplier);
    },

    init: function() {
        $(document).ready(function(ev) {
            cpfChecker = this.cpfValidator(ev);

            $('body').on('keyup', '#registration-form-cpf', cpfChecker.validateCpf);
            $('#registration-form-cpf').mask('000.000.000-00', {reverse: true});
            $('#registration-form-birthday').mask('00/00/0000');
            $('#registration-form-phone').mask(maskBehavior, options);
            $('#phone').mask(maskBehavior, options);
        }.bind(this));
    }
};
